// ADD API URLS BELOW
export const API_URLS = {
    /* Product redux urls */
    masterProduct: '/api/products/master-product',
    variantProduct: '/api/products/variant-product',
    /* Basket redux urls */
    addToBasket: '/api/basket/add-products',
    addOrderToBasket: '/api/basket/add-order',
    getBasket: '/api/basket/get-basket',
    updateBasketProduct: '/api/basket/update-product',
    deleteBasketProduct: '/api/basket/delete-product',
    validateBasket: '/api/basket/validate',
    /* Listing urls */
    getArticles: '/api/articles/get-articles',
    getCourses: '/api/courses/get-courses',
    getProducts: '/api/products/get-products',
    getDocuments: '/api/documents/get-documents',
    getDocumentDownloads: '/api/documents/get-document-downloads',
    getTypeahead: '/api/search/typeahead',
    /* Branch urls */
    getBranches: '/api/branches/get-branches',
    /* Checkout */
    checkAccount: '/api/checkout/account-check',
    submitOrder: '/api/checkout/submit',
    getBasketDelivery: '/api/checkout/delivery',
    getBasketShareUrl: '/api/checkout/shareurl',
    /* Account urls */
    extendOrderRequest: '/api/orders/extend',
    requestCollection: '/api/orders/request-collection',
    forgottenPassword: '/api/account/forgotten-password',
    getOrders: '/api/orders',
    getOrdersCSV: '/api/orders/csv',
    newsletterSignup: '/api/newsletter/signup',
    postLogin: '/api/user/login',
    resetPassword: '/api/account/reset-password',
    updateAccountDetails: '/api/account/update-details',
    updateAddressDetails: '/api/account/update-address',
    webAccountRegistration: '/api/user/web-registration',
    marketingPreferences: '/api/account/marketing-preferences',
    updatePassword: '/api/account/update-password',
    getAddresses: '/api/account/addresses-admin',
    updateAddressStatus: '/api/account/update-address',
};
